'use client';
import {PublicShell,SourceSurface} from './DownloadPage';
import {usePublicCopy} from './content/navigation';
import {useEffect,useState,type MouseEvent} from 'react';
import {legacyHashTarget} from '@zzy/contracts';
import {articles,faqItems} from './content/help';
export function HelpPage(){const {t}=usePublicCopy(),[openIds,setOpenIds]=useState<string[]>([faqItems[0].id]);
useEffect(()=>{
 const syncHash=()=>{
  const hash=location.hash.slice(1);
  if(hash==='faq'){document.getElementById(hash)?.scrollIntoView();return}
  if(!faqItems.some(item=>item.id===hash))return;
  setOpenIds(previous=>previous.includes(hash)?previous:[...previous,hash]);
  document.getElementById(hash)?.scrollIntoView();
 };
 window.addEventListener('hashchange',syncHash);
 syncHash();
 return()=>window.removeEventListener('hashchange',syncHash);
},[]);
function scrollToFaq(event:MouseEvent<HTMLAnchorElement>,id='faq'){event.preventDefault();if(id!=='faq')setOpenIds(previous=>[...new Set([...previous,id])]);document.getElementById(id)?.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'})}
return <PublicShell><SourceSurface page="help-center"><section className="section help-section" id="help-center">
          <div className="section-heading help-heading">
            <span className="help-eyebrow">{t("支持与帮助")}</span>
            <h1>{t("帮助中心")}</h1>
            <p>{t("从安装、账户到技能与创作工具，")}<br />{t("按主题找到当前版本的使用步骤与功能说明。")}</p>
            <div className="help-quick-links"><a href="#faq" onClick={scrollToFaq}>{t("浏览常见问题")}<span aria-hidden="true">↓</span></a><a href="/download">{t("下载安装助手")}<span aria-hidden="true">↗</span></a></div>
          </div>
          <div className="help-section-label"><h2>{t("按主题查找")}</h2><span>{String(articles.length).padStart(2, "0")}{t("/ 使用帮助")}</span></div>
          <div className="article-grid">
            {articles.map((article, index) => (
              <div className="article-card" key={article.title}>
                <div className="help-card-meta"><span>{t(article.date)}</span><small>{String(index + 1).padStart(2, "0")}</small></div>
                <h3>{t(article.title)}</h3>
                <p>{t(article.text)}</p>
                <a href="#faq" onClick={(event) => scrollToFaq(event, article.faqId)}>{t("查看相关解答")}<span aria-hidden="true">↗</span></a>
              </div>
            ))}
          </div>
          <div className="faq-panel" id="faq">
            <div className="faq-title">
              <span>FAQ</span>
              <h3>{t("常见问题")}</h3>
            </div>
            {faqItems.map((item, index) => (
              <details id={item.id} key={item.id} open={openIds.includes(item.id)} onToggle={event=>{const active=event.currentTarget.open;setOpenIds(previous=>active?[...new Set([...previous,item.id])]:previous.filter(id=>id!==item.id))}}>
                <summary>{t(item.question)}</summary>
                <p>{t(item.answer)}</p>
                {"href" in item ? <a className="help-answer-link" href={item.href.startsWith("#")?legacyHashTarget(item.href)??"/help":item.href}>{t(item.action)} <span aria-hidden="true">↗</span></a> : null}
              </details>
            ))}
          </div>
        </section></SourceSurface></PublicShell>}
